import type WhiteboardController from '../controllers/WhiteboardController';
import { type BaseSerializedWidget, type SerializedWidget } from '.';
import TimerWidget from './TimerWidget';
import VotingSessionWidget from './VotingSessionWidget';

const WIDGET_TYPES = {
  TimerWidget,
  VotingSessionWidget,
} as const;

// The type has to come from here because it uses WIDGET_TYPES, which
// depends on real (not type-only) versions of the widgets. If this
// was inside a file required by BaseWidget, it would cause a circular
// dependency, which breaks Jest. By exporting just the type here, we
// can use type-only imports which don't cause dependency issues.
export type WidgetType = keyof typeof WIDGET_TYPES;

// If your widget has required fields, ensure they are set with defaults in its constructor
// See TimerWidget for an example.
export default function widgetFromJSON(
  data: Omit<Partial<SerializedWidget>, 'type'> & {
    type: WidgetType;
    controller: WhiteboardController;
  }
) {
  const WidgetClass = WIDGET_TYPES[data.type];

  return new WidgetClass(data as Omit<Partial<BaseSerializedWidget>, 'type'>);
}
